// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  stackId: __t.u64().primaryKey().name("stack_id"),
  owner: __t.identity(),
  spawnId: __t.u64().name("spawn_id"),
  familyKey: __t.string().name("family_key"),
  name: __t.string(),
  statsJson: __t.string().name("stats_json"),
  qty: __t.u32(),
});
